module.exports = __webpack_public_path__ + "static/media/logo-salary.14431b73.svg";